var $f4ad3faf9f4aaec6$exports = {};
$f4ad3faf9f4aaec6$exports = {
    "breadcrumbs": `Struktura nawigacyjna`
};


export {$f4ad3faf9f4aaec6$exports as default};
//# sourceMappingURL=pl-PL.module.js.map
